import { useEffect } from "react";
import Navbar from "@/components/shared/Navbar";
import Footer from "@/components/shared/Footer";
import StickyCta from "@/components/shared/StickyCta";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import Solution from "@/components/landing/Solution";
import WhatsIncluded from "@/components/landing/WhatsIncluded";
import ServiceInclusions from "@/components/landing/ServiceInclusions";
import HowWeWorkTogether from "@/components/landing/HowWeWorkTogether";
import Pricing from "@/components/landing/Pricing";
import ComparisonTable from "@/components/landing/ComparisonTable";
import ROI from "@/components/landing/ROI";
import PricingBridge from "@/components/landing/PricingBridge";
import WhyWinCampaign from "@/components/landing/WhyWinCampaign";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import OurCommitment from "@/components/landing/OurCommitment";

export default function LandingPage() {
  useEffect(() => {
    document.title =
      "WinCampaign DFY Business Growth Accelerator™ — Your Marketing Team, Done For You";
    const meta =
      document.querySelector('meta[name="description"]') ||
      document.head.appendChild(
        Object.assign(document.createElement("meta"), { name: "description" }),
      );
    (meta as HTMLMetaElement).content =
      "The done-for-you marketing team for WinCampaign Brand Affiliates. Content, lead generation, discovery calls, and monthly growth review — starting at $348/month.";
  }, []);

  return (
    <div data-testid="wc-landing-page" id="top" className="bg-white overflow-x-hidden">
      <Navbar />
      <main>
        {/* 1. Hero */}
        <Hero />
        {/* 2. Problem — Why Most Brand Affiliates Struggle */}
        <Problem />
        {/* 3. Solution — WinCampaign DFY Business Growth Accelerator */}
        <Solution />
        {/* 4. What's Included (compact grid) */}
        <WhatsIncluded />
        {/* 4b. Deep-dive: every service you get every month */}
        <ServiceInclusions />
        {/* 5. Let's Make Your $10K/Month a Reality — Growth Planner */}
        <ROI />
        {/* 6. Traditional Marketing Agency vs. WinCampaign — price/value anchor */}
        <WhyWinCampaign />
        {/* 6b. Transition bridge: reframe cost → investment */}
        <PricingBridge />
        {/* 7. Pricing plans (PREMIUM & ELITE) */}
        <Pricing />
        {/* 8. Feature Comparison */}
        <ComparisonTable />
        {/* 9. How We Win Together — partnership + roles */}
        <HowWeWorkTogether />
        {/* 10. FAQ */}
        <FAQ />
        {/* 12. Trust & Transparency / Income Disclaimer */}
        <OurCommitment />
        {/* 13. Final CTA */}
        <FinalCTA />
      </main>
      <Footer />
      <StickyCta />
    </div>
  );
}
